import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { RetailerReceiptsPage } from '@/components/RetailerReceipts/RetailerReceiptsPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/retailer-receipts/')({
  validateSearch: listSearchSchema,
  component: RetailerReceiptsRoute,
})

function RetailerReceiptsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <RetailerReceiptsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
